import e, { OPTIONS as L } from "../../managers/braze-instance.js";
export function loadFontAwesome() {
  if (e.nn(L.Co)) return;
  const t = "https://use.fontawesome.com/7f85a56ba4.css";
  if (
    !(null !== document.querySelector('link[rel=stylesheet][href="' + t + '"]'))
  ) {
    const e = document.createElement("link");
    e.setAttribute("rel", "stylesheet"),
      e.setAttribute("href", t),
      document.getElementsByTagName("head")[0].appendChild(e);
  }
}
